import { Announcement, AnnouncementStatus, OwnerType, PropertyType, AnnouncementType } from '../models/announcement.model';

export const MOCK_SIMILAR_LISTINGS: Announcement[] = [
  {
    id: 101,
    status: AnnouncementStatus.Active,
    price: 380000,
    area_m2: 85,
    rooms: 3,
    floor: 5,
    total_floors: 12,
    address: 'Gənclik m.',
    region: 'Bakı, Nərimanov r.',
    propertyType: PropertyType.NewBuild,
    type: AnnouncementType.Sale,
    ownerType: OwnerType.Agent,
    createdAt: new Date(),
    imageUrls: ['https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?q=80&w=2070&auto=format&fit=crop'],
    isVip: false
  },
  {
    id: 102,
    status: AnnouncementStatus.Active,
    price: 365000,
    area_m2: 78,
    rooms: 3,
    floor: 10,
    total_floors: 16,
    address: 'Gənclik m.',
    region: 'Bakı, Nərimanov r.',
    propertyType: PropertyType.NewBuild,
    type: AnnouncementType.Sale,
    ownerType: OwnerType.Owner,
    createdAt: new Date(),
    imageUrls: ['https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?q=80&w=2080&auto=format&fit=crop'],
    isVip: true
  }
];
